
import * as actionTypes from "./actionTypes";

export const fetchAccountSummaryData = payload => ({
  type: actionTypes.fetchAccountSummaryDataType,
  payload
});
export const fetchBOTData = payload => ({
  type: actionTypes.fetchBotDataType,
  payload
});
